import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-3">
			Amuza estas la diskuto inter Anna Lowenstein kaj legantoj de «Esperanto» pri «poezia stilo» en Esperanto. 
			Kiel oni atendis, «simplaj esperantistoj» subtenis A.L., sed «korifeoj de Esperanta literaturo» laŭeble moke oponis ŝin.
		</p>
		
		<p class="mb-3">
			Sed la tubero en la afero estas, ke la diskuto havas alian dimension, rimarkitan nek de la komencinto de la temo, nek de ŝiaj kontraŭantoj.
		</p>
		
		<p class="mb-3">
			Ja la kialo de neologismemo ofte kuŝas ne en iu speciala strebo al elita, specifa lingvaĵo, sed en… simpla pigreco kaj foresto de logika pensado. 
			Por kio perforti sian menson, eltrovante kaj inventante Esperantajn vortojn, kiam tiel facilas simple preni la jam ekzistantajn vortojn el iu nacia lingvo! 
			Tio povas esti absoluta sinonimo (tiam al la  nova vorto oni insiste atribuas pure poezian econ, ekz., printempo – primavero). 
			Aŭ, en plej multaj kazoj, tio estas «malmala» vorto, pri kies ekzistokaŭzoj oni jam skribis kaj parolis multe.
		</p>
		
		<p class="mb-3">
			Sed ĉu poezio en Esperanto estas des pli bona, ju pli strikte ĝi sekvas la eŭropajn ekzemplojn? 
			Ĉu konataj vortoj, eĉ en Esperanta kadro, tiel ĝojigas la animojn de eŭropaj legantoj? 
			Aŭ tiuj vortoj simple rolas kiel «insuloj de sekureco» en la obskura maro de fremda lingvo, kie la radikoj eble estas kompreneblaj, sed multaj vortoj – ne, ĝuste pro ilia tipe Esperanta kunmetita formo. 
			Ja oni devas PENSI  por kompreni ilin! Kaj tiu afero estas absolute nekutima kaj neagrabla por plimulto da homoj, kaj inter ili – ho ve! – ankaŭ por plimulto da esperantistoj.
		</p>
		
		<p class="mb-3">
			Kiam mi instruis Esperanton, mi ripetadis al miaj gelernantoj: «Esperanto estas krea lingvo, kaj VI kreas ĝin! 
			Uzante la lingvon, vi konstante kreas novajn vortojn, novajn nociojn. 
			Kaj ne gravas, ke preskaŭ ĉiuj viaj kreaĵoj jam estas envortigitaj kaj uzitaj en ĉiutaga lingvaĵo. 
			Tio signifas nur, ke vi havas saman krekapablon, kiel multaj homoj antaŭ vi, ke la homaro vere povas havi komunan lingvon. 
			Kaj la mem uzado de la lingvo estas konstanta kreado, ĉar kiam vi komprenas signifon de kunmetita vorto, vi sekvas la vojon de tiu, kiu kreis ĝin, kaj tiamaniere kunkreas».
		</p>
		
		<p class="mb-3">
			Sed apenaŭ ekzistas tereno pli fremda kaj fortimiga por «simpluloj», ol libera pensado, krea potenco de la menso.
		</p>
		
		<p class="mb-3">
			Fakte, nia lingvo havas senlimajn esprimeblecojn por esprimi ne nur sentojn kaj emociojn, sed ankaŭ nociojn kaj pensojn. 
			Laŭ la hipotezo de Sapir-Whorf, la lingvo determinas la «mondon», en kiu vivas la parolanta persono. 
			Do, uzante Esperanton, ni povas krei apartan mondon, foje konstruitan tute alie, kiam ni uzas nekutimajn radik- kaj vortkunmetojn. 
			Per Esperanto ni povas esprimi tion, kio ne eblas en «normala» etna lingvo. Kiel mi komprenas, ĝuste tio estas tasko de poezio: krei novan mondon, ĉu ne?
		</p>
		
		<p class="mb-3">
			«Ĉiu poeto, verkisto estas aparta mondo» – jam trivita eldiro, kiun oni aplikas jen al Ŝekspiro, jen al Servantes, jen al aliuj gigantoj de literaturo. 
			Sed kio malfacilas en la etna lingvo, estas nekompareble pli simple atingebla en Esperanto; ja se ajnan etnan lingvon ni povas kompari kun vastega grunda vojo, betonogita per milionoj da spuroj de paŝintaj sur ĝi, tiam Esperanto similas al vasta stepo, kovrita per pura blanka neĝo, sur kiu jen kaj jen videblas ĉenetoj da spuroj: de Auld, Kaloczay, Miĥalski, De Kock.
		</p>
		
		<p class="mb-3">
			Ili kunkreis nian mondon, nian lingvon. 
			Sed kiom da spaco por kreado restis! Estu ankaŭ ni kreantoj, sed ne konsumantoj!
		</p>
		`
	)
}


const itemName = {
	esp: 'Pri lingvo poezia'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}

export default item;